/**
 *<p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年01月29日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import axios from 'axios'
import Qs from 'qs'


const instance = axios.create({
	headers: {
		'X-Requested-With': 'XMLHttpRequest'
	}
})

const baseURL = '/api'
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// instance.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'

instance.interceptors.request.use(function (config) {
	return config
}, function (error) {
	return Promise.reject(error)
})

const request = (config) => {
	return new Promise((resolve, reject) => {
		HeyUI.$LoadingBar.start()
		instance.request(Object.assign({
			baseURL: baseURL,
		}, config)).then(response => {
			let data = response.data;
			let status = response.status;
			if (status !== 200) {
				if (status === 500) {
					HeyUI.$Message.error('后台异常');
					reject();
					return
				} else if (status === 404) {
					HeyUI.$Message.error('请求不存在');
					reject();
					return
				} else if (status === 403) {
					window.location.replace("/");
					return
				} else if (status === 417) {
					HeyUI.$Message.error(response.data.msg);
					return
				}
			}
			if (data.success) {
				resolve(data);
				HeyUI.$LoadingBar.success()
			} else {
				data.msg && HeyUI.$Message.error(data.msg);
				HeyUI.$LoadingBar.success()
				resolve(data)
			}
		}).catch(err => {
				let {response, msg} = err
				if (response) {
					switch (response.status) {
						case 403:
							window.location.replace("/");
							break
						case 404:
							HeyUI.$Message.error('请求不存在');
							break
						case 500:
							HeyUI.$Message.error('后台异常');
							break
						case 417:
							HeyUI.$Message.error(response.data.msg);
							break

					}
				}
				HeyUI.$LoadingBar.fail()
				reject(msg)
			}
		)
	})
}

const transformRequest = (data, headers) => {
	return Qs.stringify(data, {allowDots: true})
}

export default {
	get(url, params = {}) {
		return request({
			url,
			params,
			method: 'get'
		})
	},
	post(url, data = {}) {
		return request({
			url,
			data,
			method: 'post',
			transformRequest: transformRequest
		})
	},
	jonsPost(url, data = {}) {
		return request({
			url,
			data,
			method: 'post',
			dataType: 'json'
		})
	},
	delete(url, params = {}) {
		return request({
			url,
			params,
			method: 'delete'
		})
	},
	upload(url, data = {}, onUploadProgress) {
		return request({
			url,
			data,
			method: 'post',
			onUploadProgress: onUploadProgress
		})
	},
	download(url, params, onDownloadProgress) {
		return request({
			url,
			params,
			method: 'get',
			responseType: 'arraybuffer',
			onDownloadProgress: onDownloadProgress
		})
	},
	put(url, data = {}) {
		return request({
			url,
			data,
			method: 'put',
			transformRequest: transformRequest
		})
	},
	baseURL
}
